import { t } from 'i18next';

import { BridgeKycStatus } from 'types/cryptoPayout';

import { makeLabels } from 'utils/i18n';

const STATUS_LABELS: Record<BridgeKycStatus, [string, string]> = {
  [BridgeKycStatus.Active]: ['active', 'Active'],
  [BridgeKycStatus.Paused]: ['paused', 'Paused'],
  [BridgeKycStatus.Pending]: ['pending', 'Pending'],
  [BridgeKycStatus.Approved]: ['approved', 'Approved'],
  [BridgeKycStatus.Incomplete]: ['incomplete', 'Incomplete'],
  [BridgeKycStatus.Rejected]: ['rejected', 'Rejected'],
  [BridgeKycStatus.AwaitingUbo]: ['awaitingUbo', 'Awaiting UBO'],
  [BridgeKycStatus.NotStarted]: ['notStarted', 'Not Started'],
  [BridgeKycStatus.UnderReview]: ['underReview', 'Under Review'],
  [BridgeKycStatus.ManualReview]: ['manualReview', 'Manual Review'],
};

const NAMESPACE = 'components.cryptoPayoutStatusBadge';
export const LABELS = makeLabels(
  {
    STATUSES: STATUS_LABELS,
  },
  NAMESPACE,
);

export const statusToLabelMap: Record<BridgeKycStatus, { type: BridgeKycStatus; label: string }> = {
  [BridgeKycStatus.Active]: {
    type: BridgeKycStatus.Active,
    label: t(LABELS.STATUSES[BridgeKycStatus.Active]),
  },
  [BridgeKycStatus.Paused]: {
    type: BridgeKycStatus.Paused,
    label: t(LABELS.STATUSES[BridgeKycStatus.Paused]),
  },
  [BridgeKycStatus.Pending]: {
    type: BridgeKycStatus.Pending,
    label: t(LABELS.STATUSES[BridgeKycStatus.Pending]),
  },
  [BridgeKycStatus.Approved]: {
    type: BridgeKycStatus.Approved,
    label: t(LABELS.STATUSES[BridgeKycStatus.Approved]),
  },
  [BridgeKycStatus.Incomplete]: {
    type: BridgeKycStatus.Incomplete,
    label: t(LABELS.STATUSES[BridgeKycStatus.Incomplete]),
  },
  [BridgeKycStatus.Rejected]: {
    type: BridgeKycStatus.Rejected,
    label: t(LABELS.STATUSES[BridgeKycStatus.Rejected]),
  },
  [BridgeKycStatus.AwaitingUbo]: {
    type: BridgeKycStatus.AwaitingUbo,
    label: t(LABELS.STATUSES[BridgeKycStatus.AwaitingUbo]),
  },
  [BridgeKycStatus.NotStarted]: {
    type: BridgeKycStatus.NotStarted,
    label: t(LABELS.STATUSES[BridgeKycStatus.NotStarted]),
  },
  [BridgeKycStatus.UnderReview]: {
    type: BridgeKycStatus.UnderReview,
    label: t(LABELS.STATUSES[BridgeKycStatus.UnderReview]),
  },
  [BridgeKycStatus.ManualReview]: {
    type: BridgeKycStatus.ManualReview,
    label: t(LABELS.STATUSES[BridgeKycStatus.ManualReview]),
  },
};
